import React, { useEffect, useState, useRef } from "react";
import "./Blogpreview.css";
import API from "../Service/Baseservice";

const BlogPreview = ({ previewBlog, onClose, setShowPreviewBlog }) => {
  const blog = previewBlog;
  const [tagMap, setTagMap] = useState({});

  useEffect(() => {
    API.post("blogtag_list/condition", { search: "", status: "active" })
      .then((res) => {
        const tagArray = res?.data?.data?.data || [];
        console.log("Fetched tag list:", tagArray);
        const map = {};
        tagArray.forEach(tag => {
          map[tag.blog_tag_id] = tag.blogtag;
        });
        setTagMap(map);
      })
      .catch((err) => console.error("Failed to fetch tags:", err));
  }, []);


  if (!blog) return <p>No blog data to preview.</p>;



  return (
    <div className="blog-preview-overlay" onClick={() => { setShowPreviewBlog(false) }}>
      <div className="blogpreview-modal" onClick={(event) => { event.stopPropagation() }}>
        <button className="close-btn" onClick={() => setShowPreviewBlog(false)}>
          ✕
        </button>
        {/* Header */}
        <div className="shadow-sm latestnewscontent aboutus d-block mx-auto col-lg-10 margintopaboutuses">
          <h1 className="newscontent">Blog</h1>
        </div>

        {/* Blog Container */}
        <div className="blogpreview-container">
          {/* Left Column */}
          <div className="left-sidep">
            <div key={blog.blog_id} className="blog-cardp">
              {blog.blog_image && (
                <div className="blog-image-wrapperp">
                  <img src={blog.blog_image} alt={blog.heading} />
                </div>
              )}
              <div className="blog-preview-contain">
                <div className="blog-metap">
                  <span>{blog.author_name || "Admin"}</span>
                  <span>{blog.blog_date?.split(" ")[0]}</span>
                  <div className="tag-display">
                    {(() => {
                      let tagIds = [];

                      if (blog.blog_tag_id) {
                        if (typeof blog.blog_tag_id === "string") {
                          try {

                            const parsed = JSON.parse(blog.blog_tag_id);
                            tagIds = Array.isArray(parsed)
                              ? parsed
                              : [parsed.toString()];
                          } catch {

                            tagIds = blog.blog_tag_id.split(",").map(id => id.trim());
                          }
                        } else if (Array.isArray(blog.blog_tag_id)) {

                          tagIds = blog.blog_tag_id;
                        } else {

                          tagIds = [String(blog.blog_tag_id)];
                        }
                      }

                      const tagNames = tagIds.map(id => tagMap[id]).filter(Boolean);

                      if (tagNames.length === 0) return null;

                      return tagNames.map((tag, i) => (
                        <span key={i} className="blog-tag">{tag}</span>
                      ));
                    })()}
                  </div>

                </div>
                <h3>{blog.heading}</h3>
                <div
                  className="blogpreview-description"
                  dangerouslySetInnerHTML={{ __html: blog.description }}
                />
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  )

};

export default BlogPreview;